import { Teaching } from "@models/ISchema";
import { InstructorTeachingRow } from "@services/types/instructor/instructorTypes";

export const getAdaptedInstructorTeachings = (
  teachings: Partial<Teaching>[] = [],
): InstructorTeachingRow[] =>
  (teachings ?? []).filter(Boolean).map((teaching, index) => ({
    id: teaching?.id ?? `${index}`,
    courseCode: teaching?.courseComponent?.course?.code ?? "",
    courseName: teaching?.courseComponent?.course?.name ?? "",
    componentName:
      teaching?.courseComponent?.component?.name ??
      teaching?.courseComponent?.component?.code ??
      "",
    contractedBlocks: teaching?.contractedBlocks ?? null,
    plannedBlocks: teaching?.plannedBlocks ?? 0,
    difference: teaching?.difference ?? null,
  }));
